// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorAlert, IDVerificationPopUp, PageLoadingSpinner } from 'ui_kit_qmd'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import moment from 'moment-timezone'
import { getTabId, getTimeZones, parseTimeZone } from '../../utils/common'
import errorIcon from '../../images/common/error-icon.svg'
import IDVerificationPopUpListener from '../../store/id-verification-pop-up/IDVerificationPopUpListener'
import { ConfirmationPopup } from '../confirmation-popup/confirmationpopup'
import { text } from './constants'
import {
  manuallyVerifyPatient,
  sendVerificationInvite,
} from '../../store/id-verification-pop-up/IDVerificationPopUpThunk'

const IDVerificationPopUpContainer = () => {
  const patientId = useRef('')
  const type = useRef('')
  const dispatch = useDispatch()
  const tabId = getTabId()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.accountSettings.adminProfile)

  const [showPopUp, setShowPopUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [userTimeZone, setUserTimeZone] = useState(parseTimeZone(profile?.TimeZone))
  const [verification, setVerification] = useState({})
  const [showManuallyVerify, setShowManuallyVerify] = useState(false)
  const [showInvite, setShowInvite] = useState(false)
  const timezones = getTimeZones(allTimezones)
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })
  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  const [timeZoneAbbr, setTimeZoneAbbr] = useState(parseTimezone(parseTimeZone(profile?.TimeZone)).label)

  useEffect(() => {
    if (profile?.TimeZone) {
      setUserTimeZone(parseTimeZone(profile?.TimeZone))
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setTimeZoneAbbr(parseTimezone(parseTimeZone(profile?.TimeZone)).label)
    } else {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUserTimeZone(parseTimezone(moment.tz.guess()).label)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setTimeZoneAbbr(parseTimezone(moment.tz.guess()).label)
    }
  }, [profile])
  const openFileVerification = useCallback(
    ({
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      PatientId,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      Url,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      Status,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      CompletedDateTime,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      VerificationId,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      PatientPhotoUrl,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      IdentityPhotoUrl,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      Overrides,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      VerificationChannels,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      ExpireDate,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      RequestDateTime,
    }) => {
      patientId.current = PatientId
      setVerification({
        Url,
        DateTime: CompletedDateTime,
        VerificationId,
        PatientPhotoUrl,
        IdentityPhotoUrl,
        Status,
        Overrides,
        VerificationChannels,
        ExpireDate,
        RequestDateTime,
      })
      setShowPopUp(true)
    },
    [setShowPopUp],
  )

  const closePopUp = useCallback(() => {
    patientId.current = ''
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setError('')
    setShowManuallyVerify(false)
    setShowInvite(false)
    setShowPopUp(false)
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const setToastMessage = useCallback((value) => {
    setError(value)
    setTimeout(() => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setError('')
    }, 3500)
  }, [])

  const handleShowManuallyVerify = useCallback(() => {
    setShowManuallyVerify(true)
  }, [])
  const handleCloseManuallyVerify = useCallback(() => {
    setShowManuallyVerify(false)
  }, [])
  const handleCloseSendInvite = useCallback(() => {
    type.current = ''
    setShowInvite(false)
  }, [])
  const manuallyVerify = useCallback(() => {
    dispatch(manuallyVerifyPatient(patientId.current, tabId))
  }, [dispatch, tabId])

  const sendRequest = useCallback(() => {
    dispatch(sendVerificationInvite(patientId.current, type.current, tabId))
  }, [dispatch, tabId])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const showSendRequestPopUp = useCallback((selectedType) => {
    type.current = selectedType
    setShowInvite(true)
  }, [])

  const closePopUps = useCallback(() => {
    setShowManuallyVerify(false)
  }, [])
  return (
    <>
      {loading ?
        <PageLoadingSpinner />
      : null}
      {showManuallyVerify ?
        // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
        <ConfirmationPopup
          title={text.MANUALLY_VERIFY}
          msg={text.MANUALLY_VERIFY_TEXT}
          primaryBtnText={text.MANUALLY_VERIFY}
          secondaryBtnText={text.CANCEL}
          primaryBtnAction={manuallyVerify}
          secondaryBtnAction={handleCloseManuallyVerify}
          closeAction={handleCloseManuallyVerify}
        />
      : null}
      {showInvite ?
        // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
        <ConfirmationPopup
          title={text.SEND_VERIFICATION_REQUEST}
          msg={text.SEND_VERIFICATION_REQUEST_MESSAGE}
          primaryBtnText={text.SEND_REQUEST}
          secondaryBtnText={text.CANCEL}
          primaryBtnAction={sendRequest}
          secondaryBtnAction={handleCloseSendInvite}
          closeAction={handleCloseSendInvite}
        />
      : null}
      <IDVerificationPopUpListener
        onSetLoading={setLoading}
        setToastMessage={setToastMessage}
        tabId={tabId}
        onOpenFileVerification={openFileVerification}
        patientId={patientId.current}
        onClosePopUp={closePopUp}
        onCloseConfirmationPopUps={closePopUps}
      />
      {showPopUp ?
        <IDVerificationPopUp
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          status={verification.Status}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          url={verification.Url}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          dateTime={verification.DateTime}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          id={verification.VerificationId}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          selfie={verification.PatientPhotoUrl}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          idPhoto={verification.IdentityPhotoUrl}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          overrides={verification.Overrides}
          onClose={closePopUp}
          timeZone={userTimeZone}
          onManuallyVerify={handleShowManuallyVerify}
          timeZoneAbbr={timeZoneAbbr}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          channels={verification.VerificationChannels}
          onSendRequest={showSendRequestPopUp}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          expireDate={verification.ExpireDate}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          requestDateTime={verification.RequestDateTime}
          isAdmin
        />
      : null}
      {error ?
        <div className='file-pop-up-error-container'>
          <ErrorAlert errorText={error} errorImg={errorIcon} imgAlt='Error' />
        </div>
      : null}
    </>
  )
}

export default IDVerificationPopUpContainer
